/**
 * @param {TimelineRecord} state
 * @param {number} itemCardViewTextWidth
 * @param {boolean} isMobileMode
 */
const getDisplayItemsWithTextSizeMap = state => state.display.displayItems;

export default getDisplayItemsWithTextSizeMap;
